import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CreateIcon from "@mui/icons-material/Create";
import Face3Icon from "@mui/icons-material/Face3";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import RecordVoiceOverRoundedIcon from "@mui/icons-material/RecordVoiceOverRounded";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SupportIcon from "@mui/icons-material/Support";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import NewspaperOutlinedIcon from "@mui/icons-material/NewspaperOutlined";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import TocRoundedIcon from "@mui/icons-material/TocRounded";

export const getMenuItems = (auth) => {
    const menuItems = [
        {
            name: "Research",
            icon: <SearchIcon />,
            items: [
                {
                    name: "Topical Calendars",
                    icon: <CalendarMonthIcon />,
                    route: "topical-calender",
                },
                {
                    name: "Ask Me Anything",
                    icon: <AutoAwesomeOutlinedIcon />,
                    route: "ask-me-anything",
                },
            ],
        },
        {
            name: "Create",
            icon: <CreateIcon />,
            items: [
                {
                    name: "Create your avatar",
                    icon: <Face3Icon />,
                    route: "create-avatar",
                },

                {
                    name: "Sound cloning",
                    icon: <RecordVoiceOverRoundedIcon />,
                    route: "voice-cloning",
                },
                {
                    name: "Product integration",
                    icon: <IntegrationInstructionsIcon />,
                    route: "product-integration",
                },
                {
                    name: "Content Ideator",
                    icon: <TocRoundedIcon />,
                    route: "content-ideator",
                },
            ],
        },
        {
            name: "Measure",
            icon: <AssessmentIcon />,
            items: [
                {
                    name: "Talent dashboard",
                    icon: <DashboardIcon />,
                    route: "talent-dashboard",
                },
                {
                    name: "Overlap",
                    icon: <CompareArrowsIcon />,
                    route: "overlap",
                },
                {
                    name: "Movie dashboard",
                    icon: <MovieCreationOutlinedIcon />,
                    route: "movie-dashboard",
                },
            ],
        },
        {
            name: "Monetize",
            icon: <MonetizationOnIcon />,
            items: [
                {
                    name: "Monetize",
                    icon: <AttachMoneyIcon />,
                    route: "monetize",
                },
            ],
        },
        {
            name: "Support",
            icon: <SupportIcon />,
            items: [
                {
                    name: "Brands",
                    icon: <BrandingWatermarkIcon />,
                    route: "brands",
                },
                // Conditionally render the Newsletter item

                {
                    name: "News Letter",
                    icon: <NewspaperOutlinedIcon />,
                    route: "newsletter",
                },
            ],
        },
        {
            name: "Admin Dashboard",
            icon: <AdminPanelSettingsIcon />,
            items: [
                {
                    name: "Executive Dashboard",
                    icon: <SupervisorAccountOutlinedIcon />,
                    route: "admin-dashboard",
                },
                ...(auth.user.role === "ADMIN"
                    ? [
                          {
                              name: "View Users",
                              icon: <GroupOutlinedIcon />,
                              route: "view-user",
                          },
                      ]
                    : []),
            ],
        },
    ];

    return menuItems;
};
